export default __webpack_public_path__ + "static/kienzler-leistung-video-2-12fc9870a8eccc8f8ce36f2ea89a62d9.mp4";